import create from 'zustand';

type AddInstanceModalStore = {
  isOpen: boolean;
  content: string;
  changeContent: (value: string) => void;
  onOpen: () => void;
  onClose: () => void;
};

export const useAddInstanceModalStore = create<AddInstanceModalStore>(set => ({
  isOpen: false,
  content: 'buttons',
  changeContent: (value: string) => set(state => ({ content: value })),
  onOpen: () => set(state => ({ isOpen: true })),
  onClose: () => set(state => ({ isOpen: false })),
}));
